import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AuthService } from './services/AuthService';

// Main hook
const useAuth = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    AuthService.initializeAuth(navigate, location, dispatch);
  }, [navigate, location.pathname, location.search, dispatch]);
};

export default useAuth;
